import { render, staticRenderFns } from "./CertificateInstructions.vue?vue&type=template&id=5f88cd90&scoped=true&"
import script from "./CertificateInstructions.vue?vue&type=script&lang=js&"
export * from "./CertificateInstructions.vue?vue&type=script&lang=js&"
import style0 from "./CertificateInstructions.vue?vue&type=style&index=0&id=5f88cd90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88cd90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex})
